import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomModal from "../../Common/CustomModal";
import Select from "react-select";
import "./style.scss";
import { useAppContext } from "../../Context/AppContext";
import { getComuneLayers, getLayer } from "../../../api";
import { ExclamationTriangleIcon } from "../../../assets/icons";
import validateGeoreferenziazione from "../../../helpers/formTools/validations/georeferenziazione/validateGeoreferenziazione";
import { getReactSelectThemeProps } from "../../../helpers/reactSelectThemeStyles";

const reactSelectThemeProps = getReactSelectThemeProps();

const GeoreferenziazioniAddModal = ({
  show,
  georeferenziazioni,
  handleClose,
  handleAddGeoreferenziazione,
}) => {
  const navigate = useNavigate();
  const { comuni } = useAppContext();
  const [selectedComune, setSelectedComune] = useState(null);
  const [layers, setLayers] = useState([]);
  const [selectedLayer, setSelectedLayer] = useState(null);
  const [layerFeatures, setLayerFeatures] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [issues, setIssues] = useState([]);


  const comuniOptions = useMemo(() => {
    console.log("!!! COMUNI MEMO: ", comuni);
    return comuni.map((item) => ({
      value: `${item.id}`,
      label: `${item.nome}`,
    }));
  }, [comuni]);

  const layersOptions = useMemo(
    () =>
      layers
        .filter((l) => l.tipo !== "limiti")
        .map((item) => ({
          value: item.id,
          label: item.tipo,
          chiave: item.chiave,
        })),
    [layers]
  );

  const featuresOptions = useMemo(
    () =>
      layerFeatures
        .map((item) => ({
          value:  item.properties[selectedLayer?.chiave] || "N/A",
          label: item.properties[selectedLayer?.chiave] || "N/A"
        })),
    [layerFeatures]
  );


  const isDisableSelect = useMemo(() => georeferenziazioni.length > 0, [georeferenziazioni]);

  const listComuneLayers = useCallback(
    async (comune) => {
      try {
        const data = await getComuneLayers(comune.value);
        setLayers(data.layers);
        return data.layers;
      } catch (error) {
        if (error?.response?.status === 401) {
          navigate("/");
          console.error(`Authorization error listing layers`);
        } else {
          toast.error(
            error.response && error.response.detail
              ? error.response.detail
              : `Unknown error listing layers`
          );
          console.error(`Authorization error listing layers`, error);
        }
      }
    },
    [navigate]
  );

  const listLayerFeatures = useCallback(
    async (layer) => {
      try {
        const data = await getLayer(layer.value);
        setLayerFeatures(data.features);
        return data.features;
      } catch (error) {
        if (error?.response?.status === 401) {
          navigate("/");
          console.error(`Authorization error listing layers`);
        } else {
          toast.error(
            error.response && error.response.detail
              ? error.response.detail
              : `Unknown error listing layers`
          );
          console.error(`Authorization error listing features`, error);
        }
      }
    },
    [navigate]
  );

  useEffect(() => {
    console.log("!!! USE EFFECT ON COMUNE CHANGE: ", selectedComune);
    if (selectedComune) listComuneLayers(selectedComune);
  }, [selectedComune, listComuneLayers]);

  useEffect(() => {
    if (selectedLayer) listLayerFeatures(selectedLayer);
  }, [selectedLayer, listLayerFeatures]);

  useEffect(() => {
    if (georeferenziazioni.length === 0) return;
    const comune = comuni.find((c) => c?.id === georeferenziazioni[0].comuneId);
    if (comune) setSelectedComune({ value: comune?.id, label: comune?.nome });
  }, [georeferenziazioni, comuni]);


  /* ALL HANDLERS */

  const onSelectedComune = (comune) => {
    console.log("onSelectedComune-->>", comune);
    setSelectedComune({value: comune.value, label: comune.label});
  };

  const onSelectedLayer = (layer) => {
    console.log("onSelectedLayer-->>", layer.value);
    setSelectedLayer({ value: layer.value, label: layer.label, chiave: layer.chiave });
  };

  const onSelectedFeature = (feature) => {
    console.log("onSelectedFeature-->>", feature.value);
    setSelectedFeature({ value: feature.value, label: feature.label });
  };

  /* TRANSFORMATIONS */



  const onAddGeoreferenziazione = (e) => {
    e.preventDefault();
    const georeferenziazione = {
      comuneId: selectedComune.value,
      tipo: selectedLayer.label,
      chiave: selectedLayer.chiave,
      valore: selectedFeature.value,
    };
    const issues = validateGeoreferenziazione(georeferenziazione);
    if (issues.length > 0) {
      setIssues(issues);
      return;
    }
    handleAddGeoreferenziazione(georeferenziazione);
  };
  console.log("!!! COMUNI: ", comuni);
  console.log("!!! COMUNI OPTIONS: ", comuniOptions);
  console.log("!!! SELECTED COMUNE: ", selectedComune);
  console.log("!!! FEATURES: ", featuresOptions);
  console.log("!!! GEOREFERENZIAZIONI: ", georeferenziazioni);
  return (
    <CustomModal
      title={"AGGIUNGI RIFERIMENTO GIS"}
      isVisible={show}
      onClose={handleClose}
    >
      <div className="issue-container">
        {issues.length > 0 &&
          issues.map((issue, index) => {
            return (
              <div key={index} className="issue">
                <p className="issue-icon">
                  <ExclamationTriangleIcon />{" "}
                </p>
                {issue}
              </div>
            );
          })}
      </div>
      <form onSubmit={onAddGeoreferenziazione}>
        <div className="add-user-modal-body">
          <div className="input-wrapper">
            <label htmlFor="comune" className="input-label">
              Comune, Frazione o Parco:
            </label>
            <Select
              options={comuniOptions}
              required
              value={selectedComune}
              isDisabled={isDisableSelect}
              placeholder="Seleziona una opzione"
              onChange={onSelectedComune}
              {...reactSelectThemeProps}
            ></Select>
          </div>
          <div className="input-wrapper">
            <label htmlFor="layer" className="input-label">
              Layer:
            </label>
            <Select
              options={layersOptions}
              required
              value={selectedLayer}
              placeholder="Seleziona una opzione"
              onChange={onSelectedLayer}
              {...reactSelectThemeProps}
            ></Select>
          </div>
          <div className="input-wrapper">
            <label htmlFor="value" className="input-label">
              {selectedLayer ? selectedLayer.chiave : "..."}
            </label>
            <Select
              options={featuresOptions.sort((a, b) => a.label.localeCompare(b.label))}
              required
              value={selectedFeature}
              placeholder="Seleziona una opzione"
              onChange={onSelectedFeature}
              {...reactSelectThemeProps}
            ></Select>
          </div>
        </div>
        <footer className="modal-footer">
          <button type="submit" className="modal-footer-button">
            Aggiungi
          </button>
        </footer>
      </form>
    </CustomModal>
  );
};

export default GeoreferenziazioniAddModal;
